import { Subscriptions } from "@bezoned/shared/features/subscriptions/subscriptions.constants.js";

import { useSubscription } from "../../subscription/subscription.context.js";
import { TeamEditFlow } from "./team-edit-flow.js";
import type { TeamEditDialogProps } from "./team-edit-flow.js";

export const TeamEditEnterpriseDialog = (props: TeamEditDialogProps) => {
  const { planId } = useSubscription();

  return (
    <TeamEditFlow
      {...props}
      isEnterprise
      isStarter={planId === Subscriptions.StarterPlan}
    />
  );
};
